<template>
  <FusionBaseDialog
    :open="open"
    @close="close"
    data-cy="subscriptionExpiredDialog"
    :persistentOverlay="true"
  >
    <template v-slot:header>
      <v-card-item>
        <v-card-title data-cy="subscriptionExpiredHeader">
          {{ $t('subscriptionExpiredDialog.title') }}
        </v-card-title>
      </v-card-item>
    </template>
    {{ $t('subscriptionExpiredDialog.message') }}
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="close"
        class="bg-primary text-white"
        variant="text"
        data-cy="subscriptionExpiredClose"
        >{{ $t('buttons.done') }}</v-btn
      >
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SubscriptionExpiredDialog',
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close'],
  methods: {
    close(): void {
      this.$emit('close')
    }
  }
})
</script>
